<template>
  <div>
    <div class="tuition" v-show="isLimit">
      <div class="tuition-white">
        <div class="title flex-between">
          <h2>课程类型</h2>
          <div class="tab">
            <p v-for="item in tabList" :key="item" :class="activeTab == item ? 'active-css' : ''" @click="tabChange(item)">
              {{ item }}
            </p>
          </div>
        </div>

        <faceclass v-if="activeTab == '面授课'" @search="searchList"></faceclass>
        <online v-else @search="searchOnlineList"></online>
      </div>

      <div v-if="(activeTab == '在线课' && onlineArr.length > 0) || (activeTab == '面授课' && resultArr.length > 0)" class="search-list tuition-white">
        <h2>查询结果</h2>

        <ul class="list-shadow">
          <div v-if="activeTab == '在线课'">
            <!-- 在线课 -->
            <div v-for="(item, index) in onlineArr" :key="index">
              <div class="line-title flex-center">
                <img src="../../assets/images/lineName.png" alt="" />
                <span v-show="item.teachMode">[{{ item.teachMode == "1" ? "直播" : item.teachMode == "2" ? "录播(随报随学)" : item.teachMode == "3" ? "直播+录播" : "" }}]</span>
                <span> {{ item.course }}</span>
              </div>
              <div class="list-flex">
                <li>
                  <h3>{{ item.officialFee || 0 }}</h3>
                  <p>官方标价</p>
                </li>
                <li>
                  <h3>{{ item.discountFee || 0 }}</h3>
                  <p>优惠服务</p>
                </li>
                <li>
                  <h3>{{ item.finalFee || 0 }}</h3>
                  <p>学费价格</p>
                </li>
              </div>
              <div v-show="item.remark" class="tip">备注：{{ item.remark }}</div>
            </div>
          </div>
          <!-- 面授课 -->
          <div v-if="activeTab == '面授课'">
            <div v-for="item in resultArr" :key="item.id">
              <div class="list-flex">
                <li>
                  <h3>{{ item.tuitionFees || 0 }}</h3>
                  <p>官方标价</p>
                </li>
                <li>
                  <h3>{{ item.preferentialPrice || 0 }}</h3>
                  <p>优惠服务</p>
                </li>
                <li>
                  <h3>{{ item.resultTuition || 0 }}</h3>
                  <p>学费价格</p>
                </li>
              </div>
              <div v-show="item.remark" class="tip">备注：{{ item.remark }}</div>
            </div>
          </div>
        </ul>
      </div>
      <div v-if="((activeTab == '在线课' && onlineArr.length <= 0) || (activeTab == '面授课' && resultArr.length <= 0)) && clickShow" class="no-data">
        <img src="../../assets/images/no_data.png" alt="" />
        <p>暂无数据</p>
      </div>
    </div>
    <emptyPage :isLimit="isLimit" />
  </div>
</template>
<script>
import online from "./components/online.vue";
import faceclass from "./components/faceClass.vue";
import { wefunstatistics, pageLimit } from "@/utils/public";
import emptyPage from "@/components/emptyPage";
export default {
  components: {
    faceclass,
    online,
    emptyPage,
  },
  data() {
    return {
      activeTab: "面授课",
      showPicker: false,
      tabList: ["面授课", "在线课"],
      resultArr: [],
      onlineArr: [],
      clickShow: false,
      isLimit: "",
    };
  },
  async created() {
    let that = this;
    await pageLimit("xfcx:query", function (bool) {
      that.isLimit = bool;
    });
    if (this.isLimit) {
      await wefunstatistics("7", window.location.href.split("#")[0]);
    }
  },
  methods: {
    searchList(arr) {
      this.resultArr = arr;
      this.clickShow = true;
    },
    searchOnlineList(arr) {
      this.clickShow = true;
      this.onlineArr = arr;
    },
    tabChange(name) {
      this.clickShow = false;
      this.activeTab = name;
      this.resultArr = [];
      this.onlineArr = [];
    },
  },
};
</script>
<style scoped lang="less">
@import "./css/index.less";
</style>
